import React, { useState, useContext, useEffect, useRef } from 'react';
import './Pairs.css';
import { useDrag } from 'react-dnd';
import { Tooltip } from '@mui/material';

const Parameter = ({ text, start, fullText }) => {
  const [{ isDragging }, drag] = useDrag(() => ({
    type: 'all',
    item: {
      ...text,
      startId: start,
    },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  }), [text]);

  const ref = useRef(null);
  drag(ref);

  const handleDrag = (e) => {
    e.stopPropagation();
  };

  // Условие для рендеринга Tooltip только если fullText длиннее, чем text
  const shouldShowTooltip = fullText && text && fullText.text.length > text.text.length;

  const content = (
    <div
      onDrag={(e) => handleDrag(e)}
      ref={ref}
      style={{
        zIndex: 2,
        cursor: 'grab',
        opacity: isDragging ? 0.3 : '',
      }}
      className='pairs__answer'
    >
      {text.text}
    </div>
  );

  return shouldShowTooltip ? (
    <Tooltip
      title={fullText.text}
      placement="top-start"
      followCursor
      componentsProps={{
        tooltip: {
          sx: {
            bgcolor: "#ffffff",
            boxShadow: "0px 4px 7px 0px #0000001C",
            color: "#000",
            fontSize: "16px",
            lineHeight: "23px",
            borderRadius: "15px",
            fontFamily: "Montserrat",
            fontWeight: 400,
            padding: "6px 15px",
            "& .MuiTooltip-arrow": {
              color: "#8E93AF",
            },
          },
        },
      }}
    >
      {content}
    </Tooltip>
  ) : (
    content
  );
};

export default Parameter;